export const offerDurationItems = [
  {
    title: '1 day',
    value: '1'
  },
  {
    title: '3 days',
    value: '3'
  },
  {
    title: '7 days',
    value: '7'
  }
];
